// Stickyheader

$(window).scroll(function () {
  if ($(this).scrollTop() > 50) {
      $("#megaheader")
          .addClass("megaheader--has-scrolled")
          .removeClass("megaheader--not-scrolled");
      $("#product-sticky-bar > div")
          .addClass("lg:translate-y-full")
          .removeClass("translate-y-full ease-in-out lg:-translate-y-[200px]");
  } else {
      $("#megaheader")
          .removeClass("megaheader--not-scrolled")
          .removeClass("megaheader--has-scrolled");
      $("#product-sticky-bar > div")
          .addClass("translate-y-full ease-in-out lg:-translate-y-[200px]")
          .removeClass("lg:translate-y-full");
  }
});

// Stickyheader

// Megaheader

$(document).ready(function () {

  var megaParentMenu__listItems = $(".megaParentMenu__listItem");
  var flyoutIsOpen = false;
  var hideFlyoutTimeout;

  function showFlyout(listItem) {
      var listItemId = listItem.attr("id");
      var flyoutContentInnerId =
          "megaheader-flyout__content-inner-" +
          listItemId.replace("megaParentMenu__listItem-", "");
      
      $(".megaheader-flyout__content-inner").removeClass("is-active");
      var flyoutContentInner = $("#" + flyoutContentInnerId);
      flyoutContentInner.addClass("is-active");

      // Calculate and set max-height based on content
      var contentHeight = $(".megaheader-flyout__content").outerHeight(true);
      $(".megaheader-flyout").css("max-height", contentHeight + "px");

      $("#megaheader").addClass("megaheader-with-flyout-open");
      $(".megaheader-flyout").addClass("isopen");
      $(".megaheader-overlay").addClass("isopen");
      updateMegaHeaderElementPositions();
      flyoutIsOpen = true;
  }

  function hideFlyout() {
      $("#megaheader").removeClass("megaheader-with-flyout-open");
      $(".megaheader-flyout").removeClass("isopen");
      $(".megaheader-overlay").removeClass("isopen");
      
      // Reset max-height
      $(".megaheader-flyout").css("max-height", "0px");
      flyoutIsOpen = false;
  }

  function updateMegaHeaderElementPositions() {
      var headerHeight = $("#megaheader").outerHeight();
      var screenHeight = $(window).height();
      
      $(".megaheader-overlay").css({
          height: screenHeight - headerHeight + "px",
          top: headerHeight + "px"
      });

      $(".megaheader-flyout").css("top", headerHeight + "px");
  }

  updateMegaHeaderElementPositions();

  $(window).resize(function () {
      updateMegaHeaderElementPositions();
  });

  megaParentMenu__listItems.on("mouseenter", function () {
      clearTimeout(hideFlyoutTimeout);
      showFlyout($(this));
  });

  megaParentMenu__listItems.on("mouseleave", function () {
      hideFlyoutTimeout = setTimeout(function () {
          if (flyoutIsOpen) {
              hideFlyout();
          }
      }, 200);
  });

  $(".megaheader-flyout").on("mouseenter", function () {
      clearTimeout(hideFlyoutTimeout);
      flyoutIsOpen = true;
  });

  $(".megaheader-flyout").on("mouseleave", function () {
      hideFlyoutTimeout = setTimeout(function () {
          hideFlyout();
      }, 200);
  });

  $(".megaheader-overlay").on("mouseenter click", function () {
      hideFlyout();
  });

  // Megaheader

  // Search / Cart Background overlay

  $(".custom-search-icon,.searchbar-close").click(function (e) {
    e.preventDefault();
    $(this).toggleClass("is-active");
    $("body").toggleClass("overflow-hidden");
    $(".header-overlay").toggleClass(
      "opacity-70 opacity-0 pointer-events-none"
    );
    $(".custom-searchbar").toggleClass(
      "invisible translate-y-10 opacity-0 visible translate-y-0 opacity-100"
    );
  });

  $(".header-overlay").click(function (e) {
    e.preventDefault();
    $(this)
      .removeClass("is-active opacity-70")
      .addClass("opacity-0 pointer-events-none");
    $("body").removeClass("overflow-hidden");
    $(".custom-searchbar")
      .removeClass("visible translate-y-0 opacity-100")
      .addClass("invisible translate-y-10 opacity-0");

    $("#megaheader").removeClass("header--has-drawer");
    $(".cart-drawer")
      .addClass("invisible translate-x-full")
      .removeClass("is-active visible translate-x-0");
  });

  // Search / Cart Background overlay

  // Cart

  $("body").on("click", ".custom-cart-icon", function () {
    $(".cart-drawer").toggleClass(
      "is-active visible translate-x-0 invisible translate-x-full"
    );
    $("body").toggleClass("overflow-hidden");
    $("#megaheader").toggleClass("header--has-drawer");
    $(".header-overlay").toggleClass(
      "opacity-70 opacity-0 pointer-events-none"
    );
  });

  $("body").on("click", ".cart_drawer-close", function () {
    $(".cart-drawer").toggleClass(
      "is-active visible translate-x-0 invisible translate-x-full"
    );
    $("body").toggleClass("overflow-hidden");
    $("#megaheader").toggleClass("header--has-drawer");
    $(".header-overlay").toggleClass(
      "opacity-70 opacity-0 pointer-events-none"
    );
  });

  function cartUpdate() {
    $(".product-item_quick-view").html("");
    $(".product-item_quick-view").hide();
    $.getJSON("/cart.js", function (cart) {
      $(".cart-toggle-count").html(cart.item_count);
    });
    $.get(
      window.location.pathname + "?section_id=cart-drawer",
      function (data) {
        $(".cart-drawer").html($(data).find(".cart-drawer").html());
        $(".cart-drawer")
          .removeClass("invisible translate-x-full")
          .addClass("is-active visible translate-x-0");
        $("body").addClass("overflow-hidden");
        $("#megaheader").addClass("header--has-drawer");
        $(".header-overlay")
          .removeClass("opacity-0 pointer-events-none")
          .addClass("opacity-70");
      }
    );
  }

  $("body").on("click", "[data-add-to-cart]", function (e) {
    e.preventDefault();
    var form = $(this).parents("form");
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          form
            .append('<p class="error">' + response.description + "</p>")
            .find(".error")
            .fadeIn()
            .delay(4000)
            .fadeOut();
        }
      },
    }).done(function (data) {
      cartUpdate();
    });
  });

  $("body").on("click", "[data-sticky-cart]", function (e) {
    $("[data-add-to-cart]").trigger("click");
  });

  $("body").on("click", "[data-cart-empty]", function (e) {
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      data: "",
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        if (jqXHR) {
          var response = $.parseJSON(jqXHR.responseText);
          alert(response.description);
        }
      },
    }).done(function (data) {
      cartUpdate();
    });
  });

  $("body").on("click", "[data-cart-qty]", function (e) {
    e.preventDefault();
    var input = $(this).parent().find("input");
    var ip = parseInt(input.val());
    if ($(this).hasClass("qty-increase")) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    input.val(ip);
    var id = parseInt(input.attr("data-id"));
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: "updates[" + id + "]=" + ip,
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
    }).done(function (data) {
      cartUpdate();
    });
  });

  $("body").on("click", "[data-cart-remove]", function (e) {
    e.preventDefault();
    var id = parseInt($(this).attr("data-id"));
    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: "updates[" + id + "]=" + 0,
      dataType: "json",
      error: function (jqXHR, textStatus, errorThrown) {
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
      },
    }).done(function (data) {
      cartUpdate();
    });
  });

  // Cart

  // Mobile Menu

  $(".mobile-back_menu").click(function () {
    $(this).parents(".menu__children").toggleClass("is-active");
  });

  $(".mega-menu-button").click(function () {
    $(this).toggleClass("is-active");
    $("body").toggleClass("overflow-hidden");
    $("#megaheader").toggleClass("header--has-drawer");
    $(".header-overlay").toggleClass("opacity-70 opacity-0");
    $(".mega-menu").toggleClass(
      "visible -translate-x-full xl:translate-x-0 xl:opacity-100 invisible translate-x-0 xl:opacity-0"
    );
    $(this)
      .find(".mega-menu-button-dash")
      .toggleClass("w-0 delay-[0ms] w-6 delay-[400ms]");
    $(this)
      .find(".mega-menu-button-close")
      .toggleClass("w-6 delay-[400ms] w-0 delay-[0ms]");
  });

  $(".menu__list > li").hover(
    function () {
      $(this).find(".menu__item").addClass("border-gray-200");
      $(this).find(".menu__item").next(".menu__children").addClass("is-active");
    },
    function () {
      $(this).find(".menu__item").removeClass("border-gray-200");
      $(this)
        .find(".menu__item")
        .next(".menu__children")
        .removeClass("is-active");
    }
  );
  // Mobile Menu

  // adventures filter menu
  
});

